import { axiosAiDataInstance } from "@/axios.instance";
import { SummaryData } from "@/store/site-monitor/types";
import { AxiosInstance } from "axios";

class AiDataApi {
    private axios: AxiosInstance;
    private ResponseSaaSPlatformType = 1;

    constructor() {
        this.axios = axiosAiDataInstance;
    }

    public setBaseApiUrl(url: string): void {
        this.axios.defaults.baseURL = url;
    }

    public async generateAiSummary(
        summaryData: SummaryData,
        apiKey: string,
        tenantId: string
    ): Promise<string> {
        const { data } = await this.axios.post(
            `/TextSummary/GenerateResponseSummary`,
            summaryData,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: apiKey,
                    ExternalKey: tenantId,
                    Platform: this.ResponseSaaSPlatformType,
                },
            }
        );

        return data;
    }
}

const aiDataApi = new AiDataApi();
export default aiDataApi;